/* istanbul ignore file */
import { UndefinedInitialDataOptions, useQuery } from "@tanstack/react-query";
import { useStanClient } from "../use-stan-client";
import { QueryKey } from "../constants";
import { TasksGetAllTasksParams, TasksListResponse } from "stan-client";

type Options = Omit<
  UndefinedInitialDataOptions<
    TasksListResponse,
    Error,
    TasksListResponse,
    (string | any)[]
  >,
  "queryKey" | "queryFn"
>;

export const useTasks = (
  params?: TasksGetAllTasksParams,
  options: Options = {}
) => {
  const client = useStanClient();

  return useQuery({
    ...options,
    placeholderData: (prev) => prev,
    queryKey: [...QueryKey.RemediationTasks, params ?? "all"],
    queryFn: async () => {
      const result = await client.tasks(params);
      return result;
    },
  });
};
